export function eventAuctionReducer(
  state = { eventAuctionData: [] },
  { type, payload }
) {
  switch (type) {
    case "EVENT_AUCTION":
      return { ...state, eventAuctionData: payload };

    default:
      return state;
  }
}

export function filterAuctionReducer(
  state = { filterAuctionData: [] },
  { type, payload }
) {
  switch (type) {
    case "FILTER_AUCTION":
      return { ...state, filterAuctionData: payload };

    default:
      return state;
  }
}

export function sellerAllAuctionReducer(
  state = { sellerAllAuctionData: [], loadings: false },
  { type, payload }
) {
  switch (type) {
    case "SELLER_ALL_AUCTION":
      return { ...state, sellerAllAuctionData: payload, loadings: false };
    case "HIDE_LOADING_ALL":
      return { ...state, loadings: false };
    case "SHOW_LOADING_ALL":
      return { ...state, loadings: true };
    default:
      return state;
  }
}

export function asideFilterAuctionReducer(
  state = {
    livefilterAuctionData: [],
    todayfilterAuctionData: [],
    upcomingfilterAuctionData: [],
    completedFilterAuction: [],
    loadinglive: false,
    loadingToday: false,
    loadingCompleted: false,
  },
  { type, payload }
) {
  switch (type) {
    case "LIVE_FILTER_AUCTION":
      return { ...state, livefilterAuctionData: payload };
    case "HIDE_LOADING_LIVE":
      return { ...state, loadinglive: false };
    case "SHOW_LOADING_LIVE":
      return { ...state, loadinglive: true };
    case "SHOW_TODAY_LOADING":
      return { ...state, loadingToday: true };
    case "SHOW_TODAY_LOADDED":
      return { ...state, loadingToday: false };
    case "TODAY_FILTER_AUCTION":
      return { ...state, todayfilterAuctionData: payload, loadingToday: false };
    case "UPCOMING_FILTER_AUCTION":
      return { ...state, upcomingfilterAuctionData: payload };
    case "COMPLETED_FILTER_AUCTION":
      return {
        ...state,
        completedFilterAuction: payload,
        loadingCompleted: false,
      };
    case "SHOW_COMPLETED_LOADDED":
      return { ...state, loadingCompleted: false };
    case "SHOW_COMPLETED_LOADING":
      return { ...state, loadingCompleted: true };

    default:
      return state;
  }
}

export function readLiveOffersReducer(
  state = { liveOffers: [], loading: false },
  { type, payload }
) {
  switch (type) {
    case "GETTING_LIVE_OFFERS":
      return { ...state, loading: true };
    case "LIVE_OFFERS":
      return { ...state, loading: false, liveOffers: payload };
    case "HIDE_LOADING":
      return { ...state, loading: false };
    default:
      return state;
  }
}

export const getAllLiveAuctionForSeller = (
  state = { liveAuctionData: [], loading: false },
  { type, payload }
) => {
  switch (type) {
    case "GETTING_ALL_LIVE_AUCTION_FOR_SELLER":
      return { ...state, liveAuctionData: payload, loading: true };
    case "GOT_ALL_LIVE_AUCTION_FOR_SELLER":
      return { ...state, liveAuctionData: payload, loading: false };
    case "CANNOT_GET_ALL_LIVE_AUCTION_FOR_SELLER":
      return { ...state, loading: false };
    default:
      return state;
  }
};

export const getAllTodayUpComingAuctionData = (
  state = {
    todayUpComingOffers: [],
    loading: false,
  },
  { type, payload }
) => {
  switch (type) {
    case "GETTING_TODAY_OFFERS":
      return { ...state, loading: true };
    case "GOT_TODAY_OFFERS":
      return { ...state, todayUpComingOffers: payload, loading: false };
    case "CANNOT_GET_TODAY_OFFERS":
      return { ...state, loading: false };
    default:
      return state;
  }
};
